import React from 'react';

import './../styles/no-logo-selector.css'

import Grid from '@mui/material/Unstable_Grid2';

import ToggleButtons from './toggle-buttons';
import { CancelIcon } from '../assets/icons/cancel';
import { CheckmarkIcon } from '../assets/icons/checkmark';

const TOGGLE_BUTTONS = [
  {
    value: 'NO',
    label1: 'With BHMA Logo',
    label2: '+ $0.00',
    icon: <CheckmarkIcon />
  },
  {
    value: 'YES',
    label1: 'Remove BHMA Logo',
    label2: '+ $2.00',
    icon: <CancelIcon />
  }
]

function NoLogoSelector({
  title,
  description,
  price,
  hasNoLogo,
  setHasNoLogo,
}) {
  const handleToggleChange = (e) => {
    setHasNoLogo(e.target.value);
  }

  return (
    <section className="no-logo-selector-container">
      <Grid container className="no-logo-title-container">
        <Grid item xs={12}>
          {!!title && (
            <h3 className="no-logo-title">{title}</h3>
          )}
          {!!description && (
            <p className="no-logo-description">{description}</p>
          )}
          {!!price && (
            <h3 className="no-logo-price">{price}</h3>
          )}
        </Grid>
      </Grid>
      <Grid container className="no-logo-toggle-container">
        <ToggleButtons
          onChange={handleToggleChange}
          value={hasNoLogo}
          buttons={TOGGLE_BUTTONS}
        />
      </Grid>
    </section>
  )
}

export default NoLogoSelector
